import classNames from 'classnames';
import React, { FC } from 'react';
import { Noop } from 'react-hook-form';
import { useBoolean } from 'usehooks-ts';
import './TextArea.scss';

type Props = {
	value: string;
	name: string;
	placeholderText: string;
	handleChange: (args: string) => void;
	theme?: 'default' | 'login';
	errorMessage?: string;
	onBlur?: Noop;
};

/**
 * A simple text field used for typing
 */
export const TextArea: FC<Props> = ({
	value,
	name,
	placeholderText,
	handleChange,
	theme,
	errorMessage,
	onBlur = () => {},
}) => {
	const { value: focused, setTrue, setFalse } = useBoolean();
	return (
		<div className="TextInputContainer">
			<textarea
				className="TextInput"
				name={name}
				id={name}
				value={value}
				onChange={(event) => handleChange(event.target.value)}
				onFocus={setTrue}
				onBlur={() => {
					onBlur();
					setFalse();
				}}
			></textarea>
			<label
				className={classNames(['TextInputLabel', `TextInputLabel--${theme}`], {
					'TextInputLabel--active': focused,
					'TextInputLabel--dirty': !!value,
					'TextInputLabel--error': errorMessage,
				})}
				htmlFor={name}
			>
				{placeholderText}
			</label>
			{errorMessage && <p className="TextInputError">{errorMessage}</p>}
		</div>
	);
};
